import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStateAdaptorService, UserType } from '@aiwyn/auth';
import { ignoreNullish } from '@aiwyn/shared';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ROUTE_TOKEN_INVOICES, ROUTE_TOKEN_MAIN_BASE } from '../routing-constants';

@Injectable({ providedIn: 'root' })
export class GuestGuard  {

  constructor(
    private readonly router: Router,
    private readonly authStateAdaptor: AuthStateAdaptorService,
  ) {}

  canActivate(..._: unknown[]): Observable<boolean> {
    return this.authStateAdaptor.getUserType().pipe(
      ignoreNullish(),
      map(userType => userType !== UserType.GUEST),
      tap(isNotGuest => {
        if (!isNotGuest) {
          this.router.navigate([ROUTE_TOKEN_MAIN_BASE, ROUTE_TOKEN_INVOICES]);
        }
      }),
    );
  }
}
